// import { supplyClassificationEnum } from "@/service/supplier-meta/enums/supplyClassificationEnum";
// import { supplyTypeEnum } from "@/service/supplier-meta/enums/supplyTypeEnum";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
import { Any } from "@/service/common/entity/Any";
import { customSupplierTypeEnum } from "@/service/supplier-meta/enums/customSupplierTypeEnum";
import { complianceTypeEnum } from "@/service/supplier-meta/enums/complianceTypeEnum";
import { getCustomSupplierType } from "./supplier-info-service";
import {
  supplierCheckByName,
  supplierCheckByBusinessNo,
} from "@/service/supplier-meta/api";
import { sourceTypeEnum } from "@/service/supplier-meta/enums/sourceTypeEnum";
import {
  genElementUITextLenValidator,
  genElementUITextByteLenValidator,
  genElementUIIntValidator,
  genElementUIFloatValidator,
  genElementUINullCharValidator,
} from "@/utils";
import { paymentTypeEnum } from "../enums/paymentTypeEnum";
import { factoryAreaEnum } from "../enums/factoryAreaEnum";
import { supplyClassificationEnum } from "../enums/supplyClassificationEnum";
import { cooperationModeEnum } from "../enums/cooperationModeEnum";
export type ElementUIValidator = (
  rules: ElementUIFormRules,
  value: Any,
  callback: (msg?: string) => void
) => void;
export interface ElementUIFormRequiredRule {
  required: boolean;
  message?: string;
  trigger?: string;
}
export interface ElementUIFormCustomRule {
  validator: ElementUIValidator;
  trigger?: string;
}
export type ElementUIFormItemRule =
  | ElementUIFormRequiredRule
  | ElementUIFormCustomRule;
export interface ElementUIFormRules {
  [x: string]: ElementUIFormItemRule[];
}
export interface SupplierFieldCtrl {
  /** 是否显示 */
  visible: boolean;
  /** 校验规则（elementui表单校验） */
  rules: ElementUIFormItemRule[];
}
/**
 * 获取字段长度限制
 * @returns
 */
export function getFieldLengthLimit(sourceType: number): {
  [x: string]: number;
} {
  const limitMap: { [x: string]: number } = {
    name: 100,
    "enterpriseInfo.operator": 50,
    "enterpriseInfo.operatorContact": 20,
    "enterpriseInfo.businessNo": 18,
    "enterpriseInfo.orgCode": 9,
    "enterpriseInfo.businessLicenseTime": 50,
    "enterpriseInfo.economicTypeCode": 100,
    "enterpriseInfo.industryAttributeCode": 100,
    "enterpriseInfo.domicileOrLocationCode": 100,
    "enterpriseInfo.webUrl": sourceType === sourceTypeEnum.oa ? 500 : 100,
    "enterpriseInfo.address":
      sourceType === sourceTypeEnum.pmc_factory ? 100 : 200,
    "linkmanInfo.linkman": sourceTypeEnum.oa === sourceType ? 32 : 10,
    "linkmanInfo.phone": sourceTypeEnum.oa === sourceType ? 20 : 16,
    "linkmanInfo.telPhone": sourceTypeEnum.oa === sourceType ? 50 : 16,
    "linkmanInfo.qq": sourceTypeEnum.oa === sourceType ? 50 : 16,
    "linkmanInfo.email": 32,
    "linkmanInfo.shopUrl": sourceTypeEnum.oa === sourceType ? 500 : 100,
    "netSellInfo.aliWangWang": 50,
    "netSellInfo.shopUrl": sourceTypeEnum.oa === sourceType ? 500 : 100,
    "linkmanInfo.address":
      sourceType === sourceTypeEnum.pmc_factory ? 100 : 200,
    "address.shipAddress": 255,
    "address.receiverName": 50,
    "address.receiverPhone": 50,
    "address.receiverAddress": 500,
  };
  return limitMap;
}
export function getSupplierFieldCtrl(
  sourceType: number,
  isClothingCategory: boolean,
  submitData: SupplierInfoSubmitBO
): { [x: string]: SupplierFieldCtrl } {
  /** 供应商类型（自定义） */
  const customSupplierType = getCustomSupplierType(
    isClothingCategory,
    submitData.factoryInfo?.supplyClassification,
    submitData.enterpriseInfo?.supplyType
  );
  const lenLimit = getFieldLengthLimit(sourceType);
  return {
    /** 经营品类 */
    "enterpriseInfo.categoryId": {
      visible: true,
      rules: [
        {
          required: true,
          message: "请选择经营品类",
          trigger: "change",
        },
      ],
    },
    /** 供货分类 */
    "factoryInfo.supplyClassification": {
      visible: isClothingCategory,
      rules: [
        {
          required: isClothingCategory,
          message: "请选择供货分类",
          trigger: "change",
        },
      ],
    },
    /** 供应链类型 */
    "enterpriseInfo.supplyType": {
      visible:
        (isClothingCategory &&
          submitData.factoryInfo?.supplyClassification ===
            supplyClassificationEnum.成衣) ||
        (!!submitData.enterpriseInfo?.categoryId && !isClothingCategory),

      rules: [
        {
          required:
            (isClothingCategory &&
              submitData.factoryInfo?.supplyClassification ===
                supplyClassificationEnum.成衣) ||
            !isClothingCategory,
          message: "请选择供应链类型",
          trigger: "change",
        },
      ],
    },
    /** 营业执照 */
    "enterpriseInfo.businessLicensePath": {
      visible: true,
      rules: [
        {
          required:
            (!!customSupplierType &&
              [
                customSupplierTypeEnum["服装_成衣_FGP/VMI"],
                customSupplierTypeEnum.服装_成衣_ODM,
                customSupplierTypeEnum.服装_成衣_OEM,
              ].includes(customSupplierType)) ||
            !isClothingCategory,
          message: "请上传营业执照",
          trigger: "change",
        },
      ],
    },
    /** 公司名称 */
    name: {
      visible: true,
      rules: [
        {
          required: true,
          message: "公司名称不能为空",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator:
            sourceType === sourceTypeEnum.oa
              ? genElementUITextLenValidator(lenLimit.name)
              : genElementUITextByteLenValidator(lenLimit.name),
          trigger: "blur",
        },
        {
          validator: async (
            rules: ElementUIFormRules,
            value: Any,
            callback: (msg?: string) => void
          ) => {
            const res = await supplierCheckByName({
              sourceType: sourceType,
              supplierName: value + "",
              bindingPhone: submitData.bindingPhone || "",
            });
            if (res && res.isSuccess && res.result) {
              callback("供应商名称已存在，请重新输入！");
            } else if (!res?.isSuccess) {
              callback("供应商名称远程校验失败！");
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    },
    /** 法人/经营者 */
    "enterpriseInfo.operator": {
      visible: true,
      rules: [
        { required: true, message: "请输入法人/经营者", trigger: "blur" },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["enterpriseInfo.operator"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 社会信用代码 */
    "enterpriseInfo.businessNo": {
      visible: true,
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请输入社会信用代码",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["enterpriseInfo.businessNo"]
          ),
          trigger: "blur",
        },
        {
          validator: (
            rules: ElementUIFormRules,
            val: Any,
            callback: (msg?: string) => void
          ) => {
            const len = 18;
            if (val && (val + "").length !== len) {
              callback(`请输入${len}位的社会信用代码`);
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
        {
          validator: (
            rules: ElementUIFormRules,
            val: Any,
            callback: (msg?: string) => void
          ) => {
            if (val) {
              supplierCheckByBusinessNo({
                sourceType: sourceType,
                businessNo: val as string,
                bindingPhone: submitData.bindingPhone || "",
              })
                .then((res) => {
                  if (!res.isSuccess) {
                    return Promise.reject();
                  }
                  if (res.result) {
                    callback("已存在该企业，不允许重复添加");
                  } else {
                    callback();
                  }
                })
                .catch(() => {
                  callback("校验社会信用代码失败！");
                });
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    },
    /** 组织机构代码 */
    "enterpriseInfo.orgCode": {
      visible: true,
      rules: [
        {
          required: [
            customSupplierTypeEnum["非服装_FGP/VMI"],
            customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            customSupplierTypeEnum["服装_成衣_FGP/VMI"],
            customSupplierTypeEnum.服装_成衣_ODM,
            customSupplierTypeEnum.服装_成衣_OEM,
          ].includes(customSupplierType as number),
          message: "请输入组织机构代码",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: (
            rules: ElementUIFormRules,
            val: Any,
            callback: (msg?: string) => void
          ) => {
            const regExp = /^.{9}$/;
            if (val && !regExp.test(val + "")) {
              callback("请输入有效的组织机构代码");
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    },
    /** 公司类型 */
    "enterpriseInfo.companyType": {
      visible: true,
      rules: [
        {
          required: true,
          message: "请选择公司类型",
          trigger: "change",
        },
      ],
    },
    /** 经营状态 */
    "enterpriseInfo.managementStatus": {
      visible: true,
      rules: [
        {
          required: true,
          message: "请选择经营状态",
          trigger: "change",
        },
      ],
    },
    /** 合规类型 */
    "enterpriseInfo.complianceType": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请选择合规类型",
          trigger: "change",
        },
      ],
    },
    /** 法人联系电话 */
    "enterpriseInfo.operatorContact": {
      visible: true,
      rules: [
        {
          required: true,
          message: "请输入法人联系电话",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["enterpriseInfo.operatorContact"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 规模类型 */
    scaleType: {
      visible: true,
      rules: [
        {
          required: true,
          message: "请选择规模类型",
          trigger: "change",
        },
      ],
    },
    /** 供应商类型 */
    supplierType: {
      visible: true,
      rules: [
        {
          required: true,
          message: "请选择供应商类型",
          trigger: "change",
        },
      ],
    },
    /** 付款类型 */
    "enterpriseInfo.paymentType": {
      visible: true,
      rules: [
        {
          required: true,
          message: "请选择付款类型",
          trigger: "change",
        },
      ],
    },
    /** 从业时间 */
    "enterpriseInfo.operatingTime": {
      visible: true,
      rules: [],
    },
    /** 从业人数 */
    "enterpriseInfo.employeeQuantity": {
      visible: true,
      rules: [
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    "enterpriseInfo.purchaseType": {
      visible: true,
      rules: [
        {
          required: true,
          message: "请选择采购类型",
          trigger: "change",
        },
      ],
    },
    /** 经济类型代码 */
    "enterpriseInfo.economicTypeCode": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请输入经济类型代码",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["enterpriseInfo.economicTypeCode"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 行业属性代码 */
    "enterpriseInfo.industryAttributeCode": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请输入行业属性代码",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["enterpriseInfo.industryAttributeCode"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 经营住所代码 */
    "enterpriseInfo.domicileOrLocationCode": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请输入经营住所代码",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["enterpriseInfo.domicileOrLocationCode"]
          ),
          trigger: "blur",
        },
      ],
    },
    "enterpriseInfo.supplyRegion": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请选择供货区域",
          trigger: "change",
        },
      ],
    },
    /** 采购类型 */
    "factoryInfo.purchaseType": {
      visible: true,
      rules: [
        {
          required: true,
          message: "请选择采购类型",
          trigger: "change",
        },
      ],
    },
    /** 提供服务 */
    serverItems: {
      visible: true,
      rules: [],
    },
    /** 官网地址 */
    "enterpriseInfo.webUrl": {
      visible: true,
      rules: [
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["enterpriseInfo.webUrl"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 联系人 */
    "linkmanInfo.linkman": {
      visible: true,
      rules: [
        { required: true, message: "请输入联系人", trigger: "blur" },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator:
            sourceType === sourceTypeEnum.oa
              ? genElementUITextLenValidator(lenLimit["linkmanInfo.linkman"])
              : genElementUITextByteLenValidator(
                  lenLimit["linkmanInfo.linkman"]
                ),
          trigger: "blur",
        },
      ],
    },
    /** 联系电话 */
    "linkmanInfo.phone": {
      visible: true,
      rules: [
        { required: true, message: "请输入手机号码", trigger: "blur" },
        {
          validator: (
            rules: ElementUIFormRules,
            val: Any,
            callback: (msg?: string) => void
          ) => {
            const regExp = /^\d{11}$/;
            if (!regExp.test(val + "")) {
              callback("请输入11位手机号码");
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["linkmanInfo.phone"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 电话号码 */
    "linkmanInfo.telPhone": {
      visible: true,
      rules: [
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["linkmanInfo.telPhone"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** qq */
    "linkmanInfo.qq": {
      visible: true,
      rules: [
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["linkmanInfo.qq"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 邮箱 */
    "linkmanInfo.email": {
      visible: true,
      rules: [
        { required: true, message: "请输入邮箱地址", trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["linkmanInfo.email"]
          ),
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: (
            rules: ElementUIFormRules,
            val: Any,
            callback: (msg?: string) => void
          ) => {
            const regExp = /^.+@[^.]+\..+$/;
            if (val && !regExp.test(val + "")) {
              callback("请输入正确的邮箱地址");
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    },
    /** 旺旺号码 */
    "netSellInfo.aliWangWang": {
      visible: true,
      rules: [
        {
          required: submitData.enterpriseInfo?.paymentTypeList?.some(
            (ele) =>
              ele.cooperationMode === cooperationModeEnum.常规采销 &&
              ele.paymentType === paymentTypeEnum.网拍
          ),
          message: "请输入阿里旺旺号",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["netSellInfo.aliWangWang"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 店铺链接 */
    "netSellInfo.shopUrl": {
      visible: true,
      rules: [
        {
          required: submitData.enterpriseInfo?.paymentTypeList?.some(
            (ele) =>
              ele.cooperationMode === cooperationModeEnum.常规采销 &&
              ele.paymentType === paymentTypeEnum.网拍
          ),
          message: "请输入店铺链接",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["netSellInfo.shopUrl"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 省 */
    "linkmanInfo.province": {
      visible: true,
      rules: [
        {
          required: true,
          message: "省份不能为空",
          trigger: "blur",
        },
      ],
    },
    /** 市*/
    "linkmanInfo.city": {
      visible: true,
      rules: [
        {
          required: true,
          message: "城市不能为空",
          trigger: "blur",
        },
      ],
    },
    /** 区 */
    "linkmanInfo.area": {
      visible: true,
      rules: [
        {
          required: true,
          message: "地区不能为空",
          trigger: "blur",
        },
      ],
    },
    /** 详细地址 */
    "linkmanInfo.address": {
      visible: true,
      rules: [
        {
          required: true,
          message: "请输入公司地址",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["linkmanInfo.address"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 是否具有研发能力 */
    "factoryInfo.developmentInfo.developmentInfoAbility": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请选择",
          trigger: "blur",
        },
      ],
    },
    /** 是否定期推荐新品 */
    "factoryInfo.developmentInfo.recomNewPrdctReg": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请选择",
          trigger: "change",
        },
      ],
    },
    /** 外贸服装品类&快时尚品类 */
    "factoryInfo.developmentInfo.isForeignFashion": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
            ].includes(customSupplierType),
          message: "请选择",
          trigger: "change",
        },
      ],
    },
    /** 产品价格区间 */
    "factoryInfo.developmentInfo.productPriceRange": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
            ].includes(customSupplierType),
          message: "请输入产品价格区间",
          trigger: "change",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
      ],
    },
    /** 月上新数 */
    "factoryInfo.developmentInfo.newQuantityMonth": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_面辅料,
            ].includes(customSupplierType),
          message: "请输入月上新数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 月打版数 */
    "factoryInfo.developmentInfo.printingQuantityMonth": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_面辅料,
            ].includes(customSupplierType),
          message: "请输入月打版数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 打版时效 */
    "factoryInfo.developmentInfo.playVersionTime": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_面辅料,
            ].includes(customSupplierType),
          message: "请输入打版时效",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 独立版房 */
    "factoryInfo.developmentInfo.standaloneRoom": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
            ].includes(customSupplierType),
          message: "请输入独立版房面积",
          trigger: "blur",
        },
        {
          validator: genElementUIFloatValidator(2),
          trigger: "blur",
        },
      ],
    },
    /** 自主设计师人数 */
    "factoryInfo.developmentInfo.independentDesigner": {
      visible: customSupplierType === customSupplierTypeEnum.服装_成衣_ODM,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_成衣_ODM,
          message: "请输入自主设计师人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 自主打版师人数 */
    "factoryInfo.developmentInfo.independentPrinter": {
      visible:
        customSupplierType === customSupplierTypeEnum.服装_成衣_ODM ||
        customSupplierType === customSupplierTypeEnum.服装_成衣_OEM,
      rules: [
        {
          required:
            customSupplierType === customSupplierTypeEnum.服装_成衣_ODM ||
            customSupplierType === customSupplierTypeEnum.服装_成衣_OEM,
          message: "请输入自主打版师人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 车版师人数 */
    "factoryInfo.developmentInfo.carVersion": {
      visible:
        customSupplierType === customSupplierTypeEnum.服装_成衣_ODM ||
        customSupplierType === customSupplierTypeEnum.服装_成衣_OEM,
      rules: [
        {
          required:
            customSupplierType === customSupplierTypeEnum.服装_成衣_ODM ||
            customSupplierType === customSupplierTypeEnum.服装_成衣_OEM,
          message: "请输入车版师人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 大货生产时效 */
    "factoryInfo.factoryManufactureInfo.bulkProductionTime": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_IPD,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_OEM,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_IPD,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_OEM,
            ].includes(customSupplierType),
          message: "请输入大货生产时效",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 首单生产周期/天  */
    "factoryInfo.factoryManufactureInfo.firstOrderProductionCycle": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请输入首单生产周期",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 订单交付周期 */
    "factoryInfo.factoryManufactureInfo.orderProductionCycle": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请输入订单交付周期",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 场地规模 */
    "factoryInfo.factoryManufactureInfo.siteScale": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
              customSupplierTypeEnum.服装_面辅料,
            ].includes(customSupplierType),
          message: "请输入场地规模（㎡）",
          trigger: "blur",
        },
        {
          validator: genElementUIFloatValidator(2),
          trigger: "blur",
        },
      ],
    },
    /** 仓储/㎡  */
    "factoryInfo.factoryManufactureInfo.storage": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
              customSupplierTypeEnum.服装_面辅料,
            ].includes(customSupplierType),
          message: "请输入仓储（㎡）",
          trigger: "blur",
        },
        {
          validator: genElementUIFloatValidator(2),
          trigger: "blur",
        },
      ],
    },
    /** 散减 */
    "factoryInfo.isPartCut": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_面辅料,
          message: "请选择是否散剪",
          trigger: "change",
        },
      ],
    },
    /** 总产能*月/万件 */
    "factoryInfo.factoryManufactureInfo.totalCapacity": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
              customSupplierTypeEnum.服装_面辅料,
            ].includes(customSupplierType),
          message: "请输入总产能",
          trigger: "blur",
        },
        {
          validator: genElementUIFloatValidator(2),
          trigger: "blur",
        },
      ],
    },
    /** 工厂产能*月万件  */
    "factoryInfo.factoryManufactureInfo.factoryCapacity": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
              customSupplierTypeEnum.服装_面辅料,
            ].includes(customSupplierType),
          message: "请输入工厂产能",
          trigger: "blur",
        },
        {
          validator: genElementUIFloatValidator(2),
          trigger: "blur",
        },
      ],
    },
    /** 外发工厂产能 */
    "factoryInfo.factoryManufactureInfo.outsourceFactoryCapacity": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
          customSupplierTypeEnum.服装_面辅料,
        ].includes(customSupplierType),
      rules: [
        {
          validator: genElementUIFloatValidator(2),
          trigger: "blur",
        },
      ],
    },
    /** 工厂性质 */
    "factoryInfo.factoryNature": {
      visible: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
          message: "请选择工厂性质",
          trigger: "change",
        },
      ],
    },
    /** 工厂区域 */
    "factoryInfo.factoryArea": {
      visible: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
          message: "请选择工厂区域",
          trigger: "change",
        },
      ],
    },
    /** 工厂人数 */
    "factoryInfo.factoryWorkers": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
          message: "请输入工厂人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 工厂类别 */
    "factoryInfo.factoryCategory": {
      visible: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
          message: "请选择工厂类别",
          trigger: "change",
        },
      ],
    },
    /** 是否特殊工艺工厂 */
    "factoryInfo.isSpecial": {
      visible: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
          message: "请选择是否是特殊工艺工厂",
          trigger: "change",
        },
      ],
    },
    /** 工厂技能 */
    "factoryInfo.factorySkill": {
      visible: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
          message: "请选择工厂技能",
          trigger: "change",
        },
      ],
    },
    /** 做工等级 */
    "factoryInfo.workLevel": {
      visible: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
      rules: [
        {
          required: customSupplierType === customSupplierTypeEnum.服装_成衣_IPD,
          message: "请选择做工等级",
          trigger: "change",
        },
      ],
    },
    /** 尾部工厂 */
    "factoryInfo.tailFactory": {
      visible:
        customSupplierType === customSupplierTypeEnum.服装_成衣_IPD &&
        submitData.factoryInfo?.factoryArea === factoryAreaEnum.怀集外发,
      rules: [
        {
          required:
            customSupplierType === customSupplierTypeEnum.服装_成衣_IPD &&
            submitData.factoryInfo?.factoryArea === factoryAreaEnum.怀集外发,
          message: "请选择尾部工厂",
          trigger: "change",
        },
      ],
    },
    /** 设备数 */
    "factoryInfo.carport": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请输入设备数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 自主尾整人数 */
    "factoryInfo.independentAilWhole": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请输入自主尾整数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 专职跟单人数 */
    "factoryInfo.fullTimeFollower": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请输入专职跟单人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 专职尾查人数 */
    "factoryInfo.fullTimeTailChecker": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请输入专职尾查人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 专职QC人数 */
    "factoryInfo.fullTimeQc": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请输入专职QC人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 专职生产管理人数 */
    "factoryInfo.fullTimeProductionManager": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请输入专职生产管理人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 专职仓储管理人数 */
    "factoryInfo.fullTimeWarehouseManager": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请输入专职仓储管理人数",
          trigger: "blur",
        },
        {
          validator: genElementUIIntValidator(),
          trigger: "blur",
        },
      ],
    },
    /** 发货地址-省 */
    "address.shipProvince": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请选择省份",
          trigger: "change",
        },
      ],
    },
    /** 发货地址-市 */
    "address.shipCity": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请选择城市",
          trigger: "change",
        },
      ],
    },
    /** 发货地址-区 */
    "address.shipArea": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请选择区域",
          trigger: "change",
        },
      ],
    },
    /** 发货地址-详细地址 */
    "address.shipAddress": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请输入详细地址",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["address.shipAddress"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 退件地址-省 */
    "address.receiverProvince": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请选择省份",
          trigger: "change",
        },
      ],
    },
    /** 退件地址-市 */
    "address.receiveCity": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请选择城市",
          trigger: "change",
        },
      ],
    },
    /** 退件地址-区 */
    "address.receiveArea": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请选择区域",
          trigger: "change",
        },
      ],
    },
    /** 退件地址-详细地址 */
    "address.receiverAddress": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请输入详细地址",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["address.receiverAddress"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 退货收件人 */
    "address.receiverName": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请输入退货收件人姓名",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["address.receiverName"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 退货联系电话 */
    "address.receiverPhone": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum["服装_成衣_FGP/VMI"],
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum["非服装_FGP/VMI"],
          customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum["服装_成衣_FGP/VMI"],
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum["非服装_FGP/VMI"],
              customSupplierTypeEnum["非服装_IPD/OEM/ODM"],
            ].includes(customSupplierType),
          message: "请输入退货联系电话",
          trigger: "blur",
        },
        { validator: genElementUINullCharValidator(), trigger: "blur" },
        {
          validator: genElementUITextByteLenValidator(
            lenLimit["address.receiverPhone"]
          ),
          trigger: "blur",
        },
      ],
    },
    /** 工厂图片-大门 */
    "factoryInfo.gatePath": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请上传图片",
          trigger: "change",
        },
      ],
    },
    /** 工厂图片-版房 */
    "factoryInfo.versionRoomPath": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请上传图片",
          trigger: "change",
        },
      ],
    },
    /** 工厂图片-展厅 */
    "factoryInfo.showroomPath": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请上传图片",
          trigger: "change",
        },
      ],
    },
    /** 工厂图片-裁床 */
    "factoryInfo.cuttingBedPath": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请上传图片",
          trigger: "change",
        },
      ],
    },
    /** 工厂图片-办公区 */
    "factoryInfo.officeAreaPath": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请上传图片",
          trigger: "change",
        },
      ],
    },
    /** 工厂图片-生产车间 */
    "factoryInfo.workshopPath": {
      visible:
        !!customSupplierType &&
        [
          customSupplierTypeEnum.服装_成衣_OEM,
          customSupplierTypeEnum.服装_成衣_ODM,
          customSupplierTypeEnum.服装_成衣_IPD,
        ].includes(customSupplierType),
      rules: [
        {
          required:
            !!customSupplierType &&
            [
              customSupplierTypeEnum.服装_成衣_OEM,
              customSupplierTypeEnum.服装_成衣_ODM,
              customSupplierTypeEnum.服装_成衣_IPD,
            ].includes(customSupplierType),
          message: "请上传图片",
          trigger: "change",
        },
      ],
    },
    /** 审厂报告 */
    "enterpriseInfo.factoryExaminingReportPath": {
      visible: customSupplierType === customSupplierTypeEnum.服装_面辅料,

      rules: [
        {
          required:
            customSupplierType === customSupplierTypeEnum.服装_面辅料 &&
            submitData.enterpriseInfo?.complianceType ===
              complianceTypeEnum.合规,
          message: "请上传审厂报告",
          trigger: "change",
        },
      ],
    },
    /** 廉洁承诺函 */
    "enterpriseInfo.honestyAgreement": {
      visible: true,

      rules: [
        {
          required: true,
          message: "请上传廉洁承诺函",
          trigger: "change",
        },
      ],
    },
    capacity: {
      visible: sourceType === sourceTypeEnum.pmc_factory,

      rules: [],
    },
  };
}
/**
 * 获取字段控制函数（带有参数sourceType，isClothingCategory，submitData缓存）
 * @param fn
 * @param sourceType
 * @param isClothingCategory
 * @param submitData
 * @returns
 */
export function getFieldCtrlFn<T>(
  fn: (
    fieldName: string,
    sourceType: number,
    isClothingCategory: boolean,
    submitData: SupplierInfoSubmitBO
  ) => T,
  sourceType: number,
  isClothingCategory: boolean,
  submitData: SupplierInfoSubmitBO
): (fieldName: string) => T {
  return (fieldName: string) => {
    return fn(fieldName, sourceType, isClothingCategory, submitData);
  };
}
/**
 * 获取字段控制函数（带有参数sourceType，isClothingCategory，submitData缓存）
 * @param fn
 * @param sourceType
 * @param isClothingCategory
 * @param submitData
 * @returns
 */
export function getFieldsCtrlFn<T>(
  fn: (
    fieldNames: string[],
    sourceType: number,
    isClothingCategory: boolean,
    submitData: SupplierInfoSubmitBO
  ) => T,
  sourceType: number,
  isClothingCategory: boolean,
  submitData: SupplierInfoSubmitBO
): (fieldNames: string[]) => T {
  return (fieldNames: string[]) => {
    return fn(fieldNames, sourceType, isClothingCategory, submitData);
  };
}
/**
 * 是否字段可见
 * @param fieldName 字段名称
 * @param sourceType 数据来源
 * @param isClothingCategory 是否服装品类
 * @param submitData 提交的数据
 * @returns
 */
export function isFieldVisible(
  fieldName: string,
  sourceType: number,
  isClothingCategory: boolean,
  submitData: SupplierInfoSubmitBO
): boolean {
  const ctrl = getSupplierFieldCtrl(sourceType, isClothingCategory, submitData);
  if (!ctrl) {
    true;
  }
  return ctrl[fieldName] ? ctrl[fieldName].visible : false;
}
/**
 * 获取字段校验规则
 * @param fieldName 字段名称
 * @param sourceType 数据来源
 * @param isClothingCategory 是否服装品类
 * @param submitData 提交的数据
 * @returns
 */
export function getFieldRules(
  fieldName: string,
  sourceType: number,
  isClothingCategory: boolean,
  submitData: SupplierInfoSubmitBO
): ElementUIFormItemRule[] {
  const ctrl = getSupplierFieldCtrl(sourceType, isClothingCategory, submitData);
  return ctrl[fieldName]?.rules || [];
}
/**
 * 获取多个字段的校验规则
 * @param fieldNames 字段名称列表
 * @param sourceType 数据来源
 * @param isClothingCategory 是否服装品类
 * @param submitData 提交的数据
 * @returns
 */
export function getFieldsRules(
  fieldNames: string[],
  sourceType: number,
  isClothingCategory: boolean,
  submitData: SupplierInfoSubmitBO
): ElementUIFormRules {
  const ctrl = getSupplierFieldCtrl(sourceType, isClothingCategory, submitData);
  const fieldCtrlMap: { [x: string]: ElementUIFormItemRule[] } = {};
  fieldNames.forEach((fieldName) => {
    if (ctrl[fieldName]) {
      fieldCtrlMap[fieldName] = ctrl[fieldName].rules;
    } else {
      fieldCtrlMap[fieldName] = [];
    }
  });
  return fieldCtrlMap;
}
/** 是否某个字段必填 */
export function isFieldRequired(
  fieldName: string,
  sourceType: number,
  isClothingCategory: boolean,
  submitData: SupplierInfoSubmitBO
): boolean {
  const ctrl = getSupplierFieldCtrl(sourceType, isClothingCategory, submitData);
  return !!ctrl[fieldName]?.rules.some(
    (rule) => (rule as ElementUIFormRequiredRule).required
  );
}
